import type {
  DigitalGiftInput,
  DigitalGiftType,
  DiscountStateEnum,
  DiscountType,
  ItemInput,
  ItemType,
  MembershipType,
  VariantType
} from "@shared/graphql.types";
import { v4 as uuid } from "uuid";

export function toPromoCode(discount: DiscountType): string | null {
  return discount?.code ?? null;
}

export function toDiscountId(promocode: string): string {
  return `__${promocode}__`;
}

export function toDiscount(promocode: string): DiscountType {
  if (!promocode) throw new Error(`toDiscount(): received null item`);

  return {
    id: toDiscountId(promocode),
    code: promocode,
    state: "indeterminate" as DiscountStateEnum,
    effects: []
  };
}

export function toPromoCodes(discounts: DiscountType[] | null): string[] {
  if (!discounts) return [];

  return discounts.map((v) => v.code).filter((v) => !!v) as string[];
}

function toDigitalGiftInput(
  gift: DigitalGiftType | null
): DigitalGiftInput | null {
  if (!gift) return null;

  return {
    ...gift,
    __typename: undefined
  } as DigitalGiftInput;
}

export function toDigitalGiftType(
  gift: DigitalGiftInput | null
): DigitalGiftType | null {
  if (!gift) return null;

  return {
    ...gift,
    __typename: undefined
  } as DigitalGiftType;
}

export function toItemInput(item: ItemType): ItemInput {
  if (!item) throw new Error(`toItemInput(): received null item`);

  return {
    id: item.id,
    type: item.type,
    membershipId: item.membership?.id ?? null,
    variantId: item.variant?.id ?? null,
    variantSku: item.variant?.sku ?? null,
    quantity: item.quantity,
    maxItemQuantity: item.variant?.maxItemQuantity ?? null,
    giftInfo: toDigitalGiftInput(item.giftInfo ?? null),
    origin: item?.origin ?? "user"
  };
}

export const variantToItemType = (variant: VariantType): ItemType => {
  return {
    id: uuid(),
    variant,
    membership: null,
    quantity: 1,
    type: "product",
    origin: "user"
  };
};

export const membershipToItemType = (membership: MembershipType): ItemType => {
  return {
    id: uuid(),
    variant: null,
    membership,
    quantity: 1,
    type: "membership",
    origin: "user"
  };
};

export const toPimId = (item: ItemInput): string => {
  return item.variantId || item.membershipId || "";
};
